import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import LoadingModal from '../../../../components/atoms/LoadingModal/index';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';
import { ScreenTitle } from '../../../../components/atoms';
import MessageModal from '../../../../components/molecules/MessageModal/index';

const TopicScreen = ({
  history,
  userId,
  sessionToken,
  loading,
  enqueueSnackbar,
  topicList,
  subtopicList,
  isNetConnected,
  showTopicList,
  purchaseStatus,

  getListOfMainTopics = () => {
  },
  resetAllHiddenQuestions = () => {
  },
  getListOfSubTopics = () => {
  },
  getQuestionByTopicId = () => {
  },
}) => {
  let { query: { sub_topic_id = '' } = {} } = qs.parseUrl(window.location.href);
  const [showResetModal, updateResetModal] = useState(false);
  const [showSubtopicModal, updateSubtopicModal] = useState(false);
  // const [topics, updateTopics] = useState([]);
  const [message, updateMessage] = useState('');
  const [subTopic, setSubTopic] = useState('');
  const [questionCount, setQuestionCount] = useState(0);
  const [subTopicId, setSubTopicId] = useState('');

  useEffect(() => {
    fetchMainTopics();
  }, []);

  const fetchMainTopics = () => {
    const topicRequestBody = {
      userId: userId,
      sessionToken: sessionToken,
    };
    getListOfMainTopics(topicRequestBody, (message, type) => {
      enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
  };

  const onResetBtn = () => {
    const resetBody = {
      userId: userId,
      sessionToken: sessionToken,
    };

    resetAllHiddenQuestions(
      resetBody,
      () => {
        updateResetModal(true);
      },
      (message, type) => {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      },
    );
  };

  const goToSubTopic = (topic, currentIndex) => {

    const subTopicRequestBody = {
      userId: userId,
      sessionToken: sessionToken,
      categoryId: topic.id,
    };

    setSubTopicId(topic.id);

    if (topic.subTopics_count > 0) {
      getListOfSubTopics(
        subTopicRequestBody,
        (qCount, sTopic) => {
          // alert("jksbff");
          setSubTopic(topic.cateName);
          setQuestionCount(qCount);
          updateSubtopicModal(true);
        },
        (message, type) => {
          enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        },
      );
    } else {
      // open mmodal
      //Alert.alert(APP_NAME, "No subtopic available");
    }
  };

  const onContinue = () => {
    setSubTopic(0);
    setQuestionCount(0);
    updateSubtopicModal(false);
    history.push(`${ROUTE_CONSTANTS.SUBTOPIC}?sub_topic_id=${subTopicId}`);
  };

  const renderMainTopics = (topicList) => {
    if (topicList.length > 0) {
      return (
        <>
          <div className='card-summary-container video_grids'>
            <div className='row'>
              {topicList.map((item, index) => {
                let { cateName, subTopics_count, id } = item;
                return (
                  <div
                    className='col6'
                    key={id}
                    onClick={() => {
                      goToSubTopic(item, index);
                    }}
                  >
                    <div className='card-summary list_videos'>
                      <h6 style={{ fontWeight: 'bold' }}>{cateName}</h6>
                      <span>Contains {subTopics_count} subtopic(s)</span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className='d-flex btn_wrap'>
              <button onClick={onResetBtn} className='blue-btn'>
                Reset Hidden Questions
              </button>
            </div>
          </div>
        </>
      );
    } else {
      return <h6 style={{ fontWeight: 'bold' }}>{'No topics available'}</h6>;
    }
  };

  return (
    <>
      <ScreenTitle title={'Topics'}/>
      {showSubtopicModal && (
        <MessageModal
          title='Sub Topics'
          message={subTopic}
          fontWeight='400'
          color={'#fff'}
          render={() => {
            return (
              <>
                <p style={{ color: '#7EBF42' }}>
                  Contains {questionCount} Quiz Question(s)
                </p>
                <button
                  style={{ width: 150, margin: 'auto', marginTop: '2.5rem' }}
                  className='start-cards-btn'
                  onClick={onContinue}
                >
                  Continue
                </button>
              </>
            );
          }}
          callback={() => {
            updateMessage('');
            updateSubtopicModal(false);
          }}
        />
      )}

      {showResetModal && (
        <MessageModal
          title='Prep2Pass'
          message={'Questions successfully reset'}
          color={'#fff'}
          fontWeight='400'
          render={() => {
            return (
              <button
                style={{
                  background: '#fff',
                  border: '1.25px solid #7ebf41',
                  color: '#7ebf41',
                  padding: '.65rem 2rem',
                  borderRadius: '5px',
                  fontWeight: 'bolder',
                  marginTop: '1rem',
                  cursor: 'pointer',
                }}
                onClick={() => updateResetModal(false)}
              >
                Okay
              </button>
            );
          }}
          callback={() => {
            updateMessage('');
            updateResetModal(false);
          }}
        />
      )}
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        renderMainTopics(topicList)
      )}
    </>
  );
};

export default withRouter(withSnackbar(TopicScreen));
